import {PurchaseError} from 'react-native-iap';

export default (_: unknown): _ is PurchaseError =>
  typeof _ === 'object' &&
  _ !== null &&
  _.hasOwnProperty('code') &&
  _.hasOwnProperty('message');
